

/**
 * Web Component for Index Banner Slider
 * Uses Splide.js for sliding functionality
 */
if (!customElements.get('index-banner')) {
  class IndexBanner extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Check if Splide is loaded
      if (typeof Splide === 'undefined') {
        console.error('Splide.js is not loaded.');
        return;
      }

      const autoplay = this.dataset.autoplay === 'true';

      this.slider = new Splide(this, {
        type: 'fade',
        rewind: true,
        autoplay: autoplay,
        interval: 5000,
        pauseOnHover: false,
        arrows: false,
        pagination: true,
        speed: 800,
      }).mount();
    }
  }

  customElements.define('index-banner', IndexBanner);
}

const tabButtons = document.querySelectorAll('.province_btn');
const tabContents = document.querySelectorAll('.province-content');

/* --------------------
   TAB SWITCHING
-------------------- */
tabButtons.forEach((btn, index) => {
  btn.addEventListener('click', () => {
    tabButtons.forEach(b => b.classList.remove('active'));
    tabContents.forEach(c => c.classList.remove('active'));

    btn.classList.add('active');
    tabContents[index].classList.add('active');
  });
});

// Activate first tab
if (tabButtons.length) {
  tabButtons[0].classList.add('active');
  tabContents[0].classList.add('active');
}

/* --------------------
   LOAD MORE (UL ONLY)
-------------------- */
tabContents.forEach(tab => {
  const lists = tab.querySelectorAll('.cnt-inr > ul'); // ONLY ULs
  const loadMoreBtn = tab.querySelector('.tab_load_more');
  let visibleCount = 9;

  // Hide ULs beyond first 9
  lists.forEach((ul, index) => {
    if (index >= visibleCount) {
      ul.style.display = 'none';
    }
  });

  // Hide button if not needed
  if (lists.length <= visibleCount) {
    loadMoreBtn.style.display = 'none';
  }

  loadMoreBtn.addEventListener('click', () => {
    const nextLists = Array.from(lists).slice(visibleCount, visibleCount + 9);

    nextLists.forEach(ul => {
      ul.style.display = 'block';
    });

    visibleCount += 9;

    // Hide button when done
    if (visibleCount >= lists.length) {
      loadMoreBtn.style.display = 'none';
    }
  });
});






class AutoScroll extends HTMLElement {
  connectedCallback() {
    const splideElm = this.querySelector(".splide");
    if (!splideElm || splideElm.dataset.mounted) return;
    splideElm.dataset.mounted = "true";

    const isCenter = this.dataset.center === "true";
    const centerPadding = this.dataset.centerPadding || 0;
    const autoWidth = this.dataset.autoWidth == "true";

    const options = {
      type: this.dataset.type || "loop",
      perPage: Number(this.dataset.perPage) || 4,
      gap: (this.dataset.gap || 0) + "px",
      arrows: this.dataset.arrows === "true",
      pagination: false,
      drag: "free",
      autoWidth: autoWidth,
      speed: 2000,


      // ✅ CENTER MODE
      focus: isCenter ? "center" : 0,
      padding: isCenter
        ? { left: `${centerPadding}px`, right: `${centerPadding}px` }
        : 0,

      breakpoints: this.parseJSON(this.dataset.breakpoints),
    };

    // Auto Scroll Extension
    if (this.dataset.autoScroll === "true") {
      options.autoScroll = {
        speed: Number(this.dataset.speed) || 1,
        pauseOnHover: true,
      };
    }

    const splide = new Splide(splideElm, options);
    splide.mount(
      this.dataset.autoScroll === "true"
        ? window.splide.Extensions
        : {}
    );
  }

  parseJSON(value) {
    try {
      return value ? JSON.parse(value) : {};
    } catch {
      return {};
    }
  }
}

customElements.define("auto-scroll", AutoScroll);



class SponsorshipScroll extends HTMLElement {
  connectedCallback() {
    const splideElm = this.querySelector(".splide");
    if (!splideElm || !window.Splide) return;

    const options = {
    type: "loop",
    drag: "free",
    focus: "center",

    autoWidth: true,   // ✅ makes slide width depend on content
    gap: "00px",

    arrows: false,
    pagination: false,

    autoScroll: {
      speed: 1,
      pauseOnHover: true,
      pauseOnFocus: false,
    },
  };

    const splide = new Splide(splideElm, options);
    
    // Mount with AutoScroll extension
    splide.mount(window.splide.Extensions);
  }
}

customElements.define("sponsorship-scroll", SponsorshipScroll);






class CollectionSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    
    const splideEl = this.querySelector('.splide');

    if (!splideEl) return;

    this.splide = new Splide(splideEl, {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      gap: '2.4rem',
      arrows: true,
      speed: 2000,
      pagination: false,
      breakpoints: {
        1024: {
          perPage: 3,
        },
        750: {
          perPage: 2,
        },
        480: {
          perPage: 1,
        }
      }
    });

    this.splide.mount();
  }
}

customElements.define('collection-slider', CollectionSlider);




class VideoSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const splideEl = this.querySelector('.splide');
    const per_page = Number(splideEl.dataset.perPage);
    if (!splideEl) return;

    this.splide = new Splide(splideEl, {
      type: 'slide',
      perPage: per_page,
      perMove: 1,
      gap: '2.4rem',
      arrows: true,
      speed: 2000,
      pagination: false,
      breakpoints: {
        1024: { perPage: 3 },
        750: { perPage: 2 },
        480: { perPage: 1 },
      },
    });

    this.splide.mount();

    const slides = this.querySelectorAll('.splide__slide');
   

    slides.forEach((item) => {
      const videoContainer = item.querySelector('.video_item');
       const plyBtn =  item.querySelector('.ply-btn');
      if (!videoContainer) return;

      item.addEventListener('click', () => {
        plyBtn.classList.add('hidden');
        // Prevent reloading video
        if (videoContainer.querySelector('video')) return;

        const tpl = item.querySelector('template');
        if (!tpl) return;

        const wrapper = tpl.content.firstElementChild.cloneNode(true);
        const video = wrapper.querySelector('video');

        videoContainer.innerHTML = '';
        videoContainer.appendChild(wrapper);

        video?.play().catch((err) => {
          console.warn('Autoplay blocked:', err);
        });
      });
    });
  }
}

customElements.define('video-slider', VideoSlider);



class TestimonialSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const splideEl = this.querySelector('.splide');

    if (!splideEl) return;

    this.splide = new Splide(splideEl, {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      gap: '3rem',
      focus: 'center',
      arrows: true,
      pagination: false,
      autoplay: true,
      interval: 3500,
      speed: 2000,
      pauseOnHover: true,
      breakpoints: {
        750: {
          perPage: 1
        }
      }
    });

    this.splide.mount();
  }
}

customElements.define('testimonial-slider', TestimonialSlider);


class VideolinkSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const splideEl = this.querySelector('.splide');

    if (!splideEl) return;

    this.splide = new Splide(splideEl, {
      type: 'slider',
      perPage: 2,
      perMove: 1,
      gap: '3rem',
      arrows: true,
      pagination: false,
      autoplay: false,
      interval: 3500,
      speed: 2000,
      pauseOnHover: true,
      breakpoints: {
        750: {
          perPage: 1
        }
      }
    });

    this.splide.mount();
  }
}

customElements.define('videolink-slider', VideolinkSlider);



class MediaSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const splideEl = this.querySelector('.splide');
    const perPage = Number(splideEl.dataset.perPage);
    const type = Number(splideEl.dataset.type);
    const progress_bar = splideEl.dataset.progressBar;
    const auto_width = splideEl.dataset.autoWidth === "true" ? true : false;
    

    if (!splideEl) return;

    this.splide = new Splide(splideEl, {
      type: type,
      perPage: perPage,
      perMove: 1,
      gap: '3rem',
      arrows: true,
      autoWidth:auto_width,
      pagination: false,
      autoplay: true,
      interval: 3500,
      speed: 2000,
      pauseOnHover: true,
      breakpoints: {
        750: {
          perPage: 1
        }
      }
    });

    if(progress_bar == "true"){

      const bar = this.querySelector('.my-slider-progress-bar');
  
      this.splide.on('mounted move',()=> {

        let end  = this.splide.Components.Controller.getEnd() + 1;
        let rate = Math.min( ( this.splide.index + 1 ) / end, 1 );
        bar.style.width = String( 100 * rate ) + '%';

      });

    }



    this.splide.mount();
  }
}

customElements.define('media-slider', MediaSlider);


// Video Url replace "learn-webinars" page

document.addEventListener('DOMContentLoaded', function () {
  const mainIframe = document.getElementById('main-video');
  const videoItems = document.querySelectorAll('.video-gallery-item');

  if (!mainIframe || videoItems.length === 0) return;

  function setActive(button) {
    document.querySelectorAll('.video-title').forEach(btn => {
      btn.classList.remove('active');
    });
    button.classList.add('active');
  }

  function setMainVideo(src) {
    if (!src) return;

    if (!src.includes('autoplay=1')) {
      src += (src.includes('?') ? '&' : '?') + 'autoplay=1';
    }

    mainIframe.setAttribute('src', src);
  }

  const firstItem = videoItems[0];
  const firstIframe = firstItem.querySelector('iframe');
  const firstButton = firstItem.querySelector('.video-title');

  if (firstIframe && firstButton) {
    setMainVideo(firstIframe.getAttribute('src'));
    setActive(firstButton);
  }

  document.querySelectorAll('.video-title').forEach(button => {
    button.addEventListener('click', function () {
      const holder = this.closest('.video-holder');
      const iframe = holder.querySelector('iframe');

      if (!iframe) return;

      setMainVideo(iframe.getAttribute('src'));
      setActive(this);

      mainIframe.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    });
  });
});





const lightbox = GLightbox({
  selector: '.glightbox',
  touchNavigation: true,
  loop: true,
  overlayColor: 'rgba(0, 0, 0, 0.71)',
  autoplayVideos: true
});


// Faq 
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq').forEach((faq) => {
      faq.addEventListener('click', function (e) {
        const header = e.target.closest('.faq-header');
        if (!header) return;

        const item = header.closest('.faq-item');
        const content = item.querySelector('.faq-content');

        // Close other items
        faq.querySelectorAll('.faq-item').forEach((el) => {
          if (el !== item) {
            closeItem(el);
          }
        });

        // Toggle current item
        if (item.classList.contains('active')) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });

    function openItem(item) {
      const content = item.querySelector('.faq-content');


      item.classList.add('active');

      if(content){

              content.style.height = content.scrollHeight + 'px';

      content.addEventListener('transitionend', function handler() {
        content.style.height = 'auto';
        content.removeEventListener('transitionend', handler);
      });
        
      }


    }

    function closeItem(item) {
      const content = item.querySelector('.faq-content');

      if(content){

      content.style.height = content.scrollHeight + 'px';
      content.offsetHeight;
      
      content.style.height = '0px';
      }

      item.classList.remove('active');
    }
  });

document.addEventListener('DOMContentLoaded', function () {
  const faqItems = document.querySelectorAll('.faq-item');
  const loadMoreBtn = document.getElementById('faq-load-more');
  const itemsPerLoad = 10;
  let currentIndex = 0;

  if (!faqItems.length || !loadMoreBtn) return;

  function showItems() {
    for (let i = currentIndex; i < currentIndex + itemsPerLoad; i++) {
      if (faqItems[i]) {
        faqItems[i].classList.add('is-visible');
      }
    }
    currentIndex += itemsPerLoad;

    if (currentIndex >= faqItems.length) {
      loadMoreBtn.style.display = 'none';
    }
  }

  // Initial load
  showItems();

  loadMoreBtn.addEventListener('click', function () {
    showItems();
  });
});



  const artlElm = document.querySelector('.article.splide');

  if (artlElm) {
    let article_splide = new Splide(artlElm, {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      gap: '2.4rem',
      arrows: true,
      speed: 2000,
      pagination: true,
      breakpoints: {
        1024: {
          perPage: 3,
        },
        750: {
          perPage: 2,
        },
        480: {
          perPage: 1,
        }
      }
    });

    article_splide.mount();
  }





class PolaroidSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const splideElement = this.querySelector('.splide');
    if (!splideElement) return;

    // Initializing with the unique settings for the Polaroid layout
    this.splideInstance = new Splide(splideElement, {
      type: 'slide',
      perPage: 2,
      perMove: 1,
      gap: '4rem',
      arrows: true,
      pagination: false,
      autoplay: false,
      interval: 4000,
      speed: 1200,
      pauseOnHover: true,
      breakpoints: {
        1199: { perPage: 2, gap: '2rem' },
        989: { perPage: 1, gap: '3rem' }
      }
    });

    this.splideInstance.mount();
  }
}

if (!customElements.get('polaroid-slider')) {
  customElements.define('polaroid-slider', PolaroidSlider);
}



class MobileGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const splideElement = this.querySelector('.splide');
    if (!splideElement) return;

    // Initializing with the unique settings for the Polaroid layout
    this.splideInstance = new Splide(splideElement, {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      gap: '4rem',
      arrows: true,
      pagination: true,
      autoplay: false,
      pauseOnHover: true,
    });

    this.splideInstance.mount();
  }
}

if (!customElements.get('mobile-gallery')) {
  customElements.define('mobile-gallery', MobileGallery);
}








